import { type ReactNode } from "react";

export type EmptyProps = {
  title: string;
  body?: ReactNode;
  action?: ReactNode;
  icon?: ReactNode;
};

export function Empty({ title, body, action, icon }: EmptyProps) {
  return (
    <div className="rounded-xl border border-dashed border-line bg-canvas-2 p-10 text-center space-y-3">
      {icon && <div className="text-ink-soft/60 flex justify-center">{icon}</div>}
      <h3 className="font-display text-lg text-ink">{title}</h3>
      {body && <p className="text-sm text-ink-soft max-w-sm mx-auto">{body}</p>}
      {action && <div className="pt-1">{action}</div>}
    </div>
  );
}
